import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03144560"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_task" }
const _hoisted_2 = {
  key: 0,
  class: "flexAlign"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("售前资料")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right flexAlign" }, [
  /*#__PURE__*/_createElementVNode("a", {
    traget: "_blank",
    href: "/template/项目管理系统售前流程2025.6.26.docx",
    style: {"color":"blue"}
  }, "售前流程资料")
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_7 = { class: "flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("任务时间")
], -1))
const _hoisted_9 = { class: "right flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 5px"} }, "-", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_12 = { class: "flexAlign" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("任务标题")
], -1))
const _hoisted_14 = { class: "right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_16 = { class: "flexAlign" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("上级任务")
], -1))
const _hoisted_18 = { class: "right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_20 = { class: "flexAlign" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("事项类型")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_23 = { class: "flexAlign" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "建模类型", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "新增新的建模类型必须陶总签字确认", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_27 = { class: "flexAlign" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("任务类型")
], -1))
const _hoisted_29 = {
  key: 1,
  style: {"height":"20px"}
}
const _hoisted_30 = {
  key: 2,
  class: "flexAlign"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("定额类型")
], -1))
const _hoisted_32 = { key: 3 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_34 = { class: "type4-grid-container" }
const _hoisted_35 = { class: "item-label" }
const _hoisted_36 = { class: "item-input-wrapper" }
const _hoisted_37 = { class: "item-hint" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_39 = { class: "flexAlign" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("计量总值")
], -1))
const _hoisted_41 = { class: "right" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_43 = { class: "flexAlign" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }),
  /*#__PURE__*/_createTextVNode("计量总工时")
], -1))
const _hoisted_45 = { class: "right" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_47 = { style: {"display":"flex"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("任务描述")
], -1))
const _hoisted_49 = { class: "right" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_51 = { class: "flexAlign" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("任务来源人")
], -1))
const _hoisted_53 = { class: "right" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_55 = { class: "flexAlign" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("任务来源")
], -1))
const _hoisted_57 = { class: "right" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_59 = { class: "flexAlign" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("执行人")
], -1))
const _hoisted_61 = { class: "right" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_63 = { class: "flexAlign" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("审核人")
], -1))
const _hoisted_65 = { class: "right" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_67 = { class: "flexAlign" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("状态")
], -1))
const _hoisted_69 = { class: "right" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_71 = { style: {"display":"flex"} }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " "),
  /*#__PURE__*/_createTextVNode("附件")
], -1))
const _hoisted_73 = { class: "right" }
const _hoisted_74 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_76 = { class: "paste_tip" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_78 = { class: "flexCenter" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("提 交")

import { ref,onMounted,onBeforeUnmount, watch } from 'vue';
	import { xmUser,requestAddTask,xmDetails2,requestTaskGanttList } from '@/api/xmApi';
	import { apiName,requestMyuser } from '@/api/api';
	import { ElMessage } from 'element-plus';
	import {
        requestGetAllConfig
    } from '@/api/configApi.js';
	import type { UploadUserFile } from 'element-plus'
	
export default /*#__PURE__*/_defineComponent({
  name: 'AddTask',
  props: {
		id:{
			type: Number,
			default: 0
		},
		taskid:{
			type: Number,
			default: 0
		},
		projectid:{
			type: Number,
			default: 0
		}
	},
  emits: ['cancelTask'],
  setup(__props, { emit }) {

const props = __props

	const fileList = ref<UploadUserFile[]>([])
	
	const api = ref<string>(apiName)
	
	const form = ref<any>({
		type1:'',
		startdate:'',
		enddate:'',
		tasktitle:'',
		taskdescribe:'',
		status:1,
		operatoruserid:0,
		operatorname:'',
		checkuserid:0,
		checkname:'',
		type2:'', 
		type3:'', 
		maxjl:'',
		maxjlgs:'',
		jmtype:'',
		lyname:'',
		ly:'',
		type4Quantities: {},
		type4json: '',
	})
	const projectinfotype1= ref<string>("")
	const projectinfo = ref({type1:''})
	// 上级任务：默认取传入的 taskid，可改为同项目下其他任务
	const taskParentId = ref<number>(props.taskid || 0)
	const projectTaskList = ref<any[]>([])//同项目下的任务列表（可选为上级任务）
	const lyname = ref<string>("")//执行人
	const zxr = ref<string>("")//执行人
	const shr = ref<string>("")//审核人
	// 获取全部人员命名
	const userLists = ref<any[]>([])
	const sxlxLists = ref<any[]>([])
	const type2Lists = ref<any[]>([])
	const type3Lists = ref<any[]>([])
	const type4Lists = ref<any[]>([])
	const jmlxLists = ref<any[]>([])
	//提交
	const submit = () => {
		let fjArr:any[] = []
		fileList.value.forEach((val:any)=>{
			let u = '', nm = ''
			if (val.response && val.response.data && val.response.data[0]) {
				u = val.response.data[0].url
				nm = val.response.data[0].name ? decodeURIComponent(val.response.data[0].name) : ''
			} else if (val.url) {
				// 编辑回显等场景：url 可能已含 |name
				const idx = val.url.indexOf('|')
				if (idx >= 0) { u = val.url.substring(0, idx); nm = val.url.substring(idx + 1) }
				else { u = val.url }
			}
			fjArr.push(u + (nm ? '|' + nm : ''))
		})
		if(form.value.tasktitle === ""){
			ElMessage.error("请输入任务标题");
			return
		}
		if(form.value.type1 === ""){
			ElMessage.error("请选择事项类型");
			return
		}
		if(form.value.ly === ""){
			ElMessage.error("任务来源不可为空");
			return
		}
		if(form.value.type2 ==="计量任务"){
			if(form.value.maxjlgs==""){
				ElMessage.error("计量任务，计量总工时不可为空");
				return
			}
			if(isNaN(parseFloat(form.value.maxjlgs))){
				ElMessage.error("请输入数字");
				return
			}
			if((parseFloat(form.value.maxjlgs))<=0){
				ElMessage.error("请输入大于0数字");
				return
			}
		}else{
			if(form.value.maxjlgs==""){
				form.value.maxjlgs=0.00
			}
		}
		if(zxr.value != ""){
			form.value.operatoruserid = parseInt(zxr.value.split(",")[0])
			form.value.operatorname = zxr.value.split(",")[1]
		}
		if(shr.value != ""){
			form.value.checkuserid = parseInt(shr.value.split(",")[0])
			form.value.checkname = shr.value.split(",")[1]
		}
		if(lyname.value != ""){
			form.value.lyname = lyname.value.split(",")[1]
		}else{
			ElMessage.error("任务来源人不可为空");
			return
		}
		requestAddTask({
			projectid:props.id,
			taskpid:taskParentId.value || 0,
			type1:form.value.type1,
			startdate:form.value.startdate,
			enddate:form.value.enddate,
			tasktitle:form.value.tasktitle,
			taskdescribe:form.value.taskdescribe,
			operatoruserid:form.value.operatoruserid,
			operatorname:form.value.operatorname,
			checkuserid:form.value.checkuserid,
			checkname:form.value.checkname,
			status:form.value.status,
			filelist:fjArr.join(","),
			type2:form.value.type2,
			maxjl:form.value.maxjl,
			maxjlgs:form.value.maxjlgs,
			jmtype:form.value.jmtype,
			lyname:form.value.lyname,
			ly:form.value.ly,
			type3:form.value.type3,
			type4jsonstr:form.value.type4json,
		}).then((res:any)=>{
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
			setTimeout(()=>{
				emit("cancelTask",1)
			},500)
		})
	}
	// ===== 附件 Ctrl + V 粘贴上传 =====
	// 本组件只有一个附件栏目，粘贴的附件直接上传到该栏目
	const pasteUploading = ref<boolean>(false)
	const uploadPasteFile = (file: File) => {
		pasteUploading.value = true
		const fd = new FormData()
		fd.append('file', file, file.name || ('paste_' + Date.now()))
		fetch(`${api.value}/frame/uploadfile1`, { method:'POST', credentials:'same-origin', body: fd })
			.then((r:any)=>r.json())
			.then((res:any)=>{
				if(res && res.errno === 0 && res.data && res.data[0]){
					const url = res.data[0].url || ''
					const rawName = res.data[0].name || ''
					const name = rawName ? decodeURIComponent(rawName) : (file.name || '附件')
					// 用 concat 而非展开语法：项目 tslib 版本较旧，缺少 __spreadArray 帮助器
				fileList.value = fileList.value.concat([{ name, url, response: { data: [{ url, name: rawName }] } }] as any)
					ElMessage({ message: '附件已上传', type: 'success', duration: 800 })
				}else{
					ElMessage({ message: (res && res.msg) || '附件上传失败', type: 'error', duration: 800 })
				}
			})
			.catch(()=>{
				ElMessage({ message: '附件上传失败', type: 'error', duration: 800 })
			})
			.finally(()=>{
				pasteUploading.value = false
			})
	}
	const onPaste = (e: ClipboardEvent) => {
		const items = e.clipboardData && e.clipboardData.items
		if(!items) return
		const files: File[] = []
		for(let i=0;i<items.length;i++){
			const it:any = items[i]
			if(it && it.kind === 'file' && it.getAsFile){
				const f = it.getAsFile()
				if(f) files.push(f)
			}
		}
		if(files.length === 0) return//纯文本粘贴不拦截，不影响输入框正常粘贴
		e.preventDefault()
		files.forEach((f:File)=>uploadPasteFile(f))
	}
	const cancel = () => {
		emit("cancelTask")
	}
	onMounted(()=>{
		// 附件支持 Ctrl + V 粘贴上传
		document.addEventListener('paste', onPaste)
		console.log(props)
		if(props.form1){
			console.log(props)
			console.log(props.id);
			console.log(props.projectid);
		}
		GetxmDetails2();
		getUserList();
		getDate();
		getMyUser();
		getSxlx();
		gettype2list();
		getProjectTaskList();
		})

		onBeforeUnmount(()=>{
		document.removeEventListener('paste', onPaste)
		})

		// 查询同项目下的任务，供选择上级任务（非关闭任务，不分页）
	const getProjectTaskList = () => {
		if(!props.id){
			projectTaskList.value = []
			return
		}
		requestTaskGanttList({
			projectid:props.id
		}).then((res:any)=>{
			if(Array.isArray(res)){
				projectTaskList.value = res
			}else{
				projectTaskList.value = (res && res.datalist) || []
			}
		}).catch(()=>{
			projectTaskList.value = []
		})
	}
	const GetxmDetails2 = () => {
        xmDetails2({
            id:props.id
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(111222)
            	console.log(res.datalist);
            	if( res.datalist.length!=0){
            		projectinfo.value = res.datalist[0]
                	projectinfotype1.value=projectinfo.value.type1;
                	console.log(projectinfotype1.value);
            	}
            }
        })
    }
	const getSxlx = () => {
		console.log("sxlx");
        requestGetAllConfig({
            type:"事项类型"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                sxlxLists.value = res.datalist
            }
        })
		requestGetAllConfig({
            type:"建模分类"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                jmlxLists.value = res.datalist
            }
        })
		
		
    }
    const gettype2list  = () => {
		console.log("sxlx");
        requestGetAllConfig({
            type:"tasktype2"
        }).then((res:any)=>{
            if(res.status === 1){
                type2Lists.value = res.datalist
            }
        })
		requestGetAllConfig({
            type:"tasktype3"
        }).then((res:any)=>{
            if(res.status === 1){
                type3Lists.value = res.datalist
            }
        })
    }
    

	const getDate = () => {
		// 今天的日期
		let date = new Date();
		let YY = date.getFullYear() + '-';
		let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
		form.value.startdate = `${YY}${MM}${DD}`
		//明天的日期
		let finalDate = new Date(date)
		let nextDate = new Date(finalDate.setDate(date.getDate() + 1))
		let nextYY = nextDate.getFullYear() + '-';
		let nextMM = (nextDate.getMonth() + 1 < 10 ? '0' + (nextDate.getMonth() + 1) : nextDate.getMonth() + 1) + '-';
		let nextDD = (nextDate.getDate() < 10 ? '0' + (nextDate.getDate()) : nextDate.getDate());
		form.value.enddate = `${nextYY}${nextMM}${nextDD}`
	}
	const getUserList = () =>{
		xmUser().then((res:any)=>{
			if(res.status === 1){
				userLists.value = res.datalist
			}
		})
	}
	const getMyUser = () => {
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				shr.value = `${res.datalist[0].id},${res.datalist[0].name}`
			}
		})
	}

	watch(() => form.value.type2, (newType) => {
     	if (newType === '计量任务' || newType === '定额任务') {
			// 只有当开始时间存在时才同步，避免清空或设置无效日期
			if (form.value.startdate) {
				form.value.enddate = form.value.startdate;
			}
			if(newType === '计量任务' ){
				form.value.type3="";
			}
     	}else{
			form.value.type3="";
		}
 	});
	watch(() => form.value.type3, (newType) => {
     	requestGetAllConfig({
            type:"tasktype4",
			key:newType
        }).then((res:any)=>{
            if(res.status === 1){
                type4Lists.value = res.datalist
            }else{
				type4Lists.value = []
			}
        })
 	});
	 const calculateTotalTime = () => {
		let totalTime = 0;
		let totalcount = 0;
		let txt ="";
		let objlist = [];
		if (type4Lists.value && type4Lists.value.length > 0) {
			type4Lists.value.forEach((item: any) => {
				const qty = form.value.type4Quantities[item.id];
				if (qty && !isNaN(Number(qty))) {
					const factor = parseFloat(item.field0);
					if (!isNaN(factor)) {
						totalTime += Number(qty) * factor;
						totalcount += Number(qty);
						txt+=item.value+"*"+Number(qty)+"；"
						objlist.push({confid:item.id,name:item.value,qty:qty})
					}
				}
			});
		}
		// 保留两位小数
		form.value.maxjl=totalcount > 0 ? totalcount : 0;
		form.value.maxjlgs = totalTime > 0 ? totalTime.toFixed(2) : '';
		form.value.taskdescribe=txt;
		form.value.type4json = JSON.stringify(objlist);
		console.log(form.value.type4json)
	 }

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (projectinfotype1.value=='1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_date_picker, {
          modelValue: form.value.startdate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.startdate) = $event)),
          type: "date",
          placeholder: "开始时间",
          "value-format": "YYYY-MM-DD"
        }, null, 8, ["modelValue"]),
        _hoisted_10,
        _createVNode(_component_el_date_picker, {
          modelValue: form.value.enddate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.enddate) = $event)),
          type: "date",
          placeholder: "结束时间",
          "value-format": "YYYY-MM-DD"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_input, {
          modelValue: form.value.tasktitle,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.tasktitle) = $event)),
          placeholder: "请输入任务标题",
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (submit()), ["enter","native"]))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_select, {
          filterable: "",
          clearable: "",
          modelValue: taskParentId.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((taskParentId).value = $event)),
          placeholder: "请选择上级任务（不选则为顶级任务）",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "无（作为顶级任务）",
              value: 0
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectTaskList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.tasktitle,
                value: Number(item.id),
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createVNode(_component_el_select, {
        modelValue: form.value.type1,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.type1) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sxlxLists.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.value,
              value: `${item.value}`,
              key: index
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createVNode(_component_el_select, {
        modelValue: form.value.jmtype,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.jmtype) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jmlxLists.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.value,
              value: `${item.value}`,
              key: index
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_25
    ]),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createVNode(_component_el_select, {
        modelValue: form.value.type2,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.type2) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type2Lists.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.value,
              value: `${item.value}`,
              key: index
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (form.value.type2 === '定额任务')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29))
      : _createCommentVNode("", true),
    (form.value.type2 === '定额任务')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _hoisted_31,
          _createVNode(_component_el_select, {
            modelValue: form.value.type3,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.type3) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type3Lists.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.value,
                  value: `${item.value}`,
                  key: index
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (form.value.type3 != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type4Lists.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "type4-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(item.value), 1),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.type4Quantities[item.id],
                    "onUpdate:modelValue": ($event: any) => ((form.value.type4Quantities[item.id]) = $event),
                    modelModifiers: { number: true },
                    placeholder: "个数",
                    onInput: calculateTotalTime
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("span", _hoisted_37, " (系数: " + _toDisplayString(item.field0) + ") ", 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_38,
    _createElementVNode("div", _hoisted_39, [
      _hoisted_40,
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_component_el_input, {
          modelValue: form.value.maxjl,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.maxjl) = $event)),
          placeholder: "请输入计量任务总值",
          onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (submit()), ["enter","native"])),
          style: {"width":"220px"}
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_42,
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createVNode(_component_el_input, {
          modelValue: form.value.maxjlgs,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.maxjlgs) = $event)),
          placeholder: "请输入计量总工时",
          onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (submit()), ["enter","native"])),
          style: {"width":"220px"}
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_46,
    _createElementVNode("div", _hoisted_47, [
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        _createVNode(_component_el_input, {
          autosize: {minRows: 8},
          type: "textarea",
          modelValue: form.value.taskdescribe,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.taskdescribe) = $event)),
          placeholder: "请输入任务描述"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_50,
    _createElementVNode("div", _hoisted_51, [
      _hoisted_52,
      _createElementVNode("div", _hoisted_53, [
        _createVNode(_component_el_select, {
          filterable: "",
          modelValue: lyname.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((lyname).value = $event)),
          placeholder: "请选择",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: `${item.id},${item.name}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_54,
    _createElementVNode("div", _hoisted_55, [
      _hoisted_56,
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_el_input, {
          modelValue: form.value.ly,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.ly) = $event)),
          placeholder: "请输入任务来源",
          onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (submit()), ["enter","native"]))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_58,
    _createElementVNode("div", _hoisted_59, [
      _hoisted_60,
      _createElementVNode("div", _hoisted_61, [
        _createVNode(_component_el_select, {
          filterable: "",
          modelValue: zxr.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((zxr).value = $event)),
          placeholder: "请选择",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: `${item.id},${item.name}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_62,
    _createElementVNode("div", _hoisted_63, [
      _hoisted_64,
      _createElementVNode("div", _hoisted_65, [
        _createVNode(_component_el_select, {
          filterable: "",
          modelValue: shr.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((shr).value = $event)),
          placeholder: "请选择",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: `${item.id},${item.name}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_66,
    _createElementVNode("div", _hoisted_67, [
      _hoisted_68,
      _createElementVNode("div", _hoisted_69, [
        _createVNode(_component_el_select, {
          modelValue: form.value.status,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.status) = $event)),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "进行中",
              value: 1
            }),
            _createVNode(_component_el_option, {
              label: "关闭",
              value: 2
            }),
            _createVNode(_component_el_option, {
              label: "提交待审核",
              value: 3
            }),
            _createVNode(_component_el_option, {
              label: "完成",
              value: 4
            }),
            _createVNode(_component_el_option, {
              label: "未启动",
              value: 0
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_70,
    _createElementVNode("div", _hoisted_71, [
      _hoisted_72,
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createVNode(_component_el_upload, {
            action: `${api.value}/frame/uploadfile1`,
            "file-list": fileList.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_75
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["action", "file-list"]),
          _createElementVNode("span", _hoisted_76, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴上传'), 1)
        ])
      ])
    ]),
    _hoisted_77,
    _createElementVNode("div", _hoisted_78, [
      _createVNode(_component_el_button, {
        onClick: _cache[20] || (_cache[20] = ($event: any) => (cancel())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_79
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[21] || (_cache[21] = ($event: any) => (submit())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_80
        ]),
        _: 1
      })
    ])
  ]))
}
}

})